import useAbilityStore from '@/store/useAbilityStore';
import {AccessControlProvider} from '@refinedev/core';

const accessControlProvider: AccessControlProvider = {
  can: async ({resource, action, params}) => {
    const {can, ability, ability2} = useAbilityStore.getState();
    if (!ability && !ability2) return {can: false, reason: 'No ability found'};

    return {can: can(action, resource || 'all', params), reason: 'No reason'};
  },
  options: {
    buttons: {
      enableAccessControl: true,
      hideIfUnauthorized: false,
    },
    queryOptions: {
      // ... default global query options
    },
  },
};

export default accessControlProvider;
